import { Card } from "flowbite-react";
import { useTranslation } from "../i18n/LanguageContext";


const WorkCard = () => {
    const { t } = useTranslation();
    return (
        <Card
            className="max-w-sm"
            imgAlt={t("works.cards.teatro.imgAlt")}
            imgSrc="/images/blog/image-1.jpg"
        >
            <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                {t("works.cards.teatro.title")}
            </h5>
            <p className="font-normal text-gray-700 dark:text-gray-400">
                {t("works.cards.teatro.description")}
            </p>
            <ul className="list-disc ml-5 text-gray-700 dark:text-gray-400">
                <li>{t("works.cards.teatro.bullets.b1")}</li>
                <li>{t("works.cards.teatro.bullets.b2")}</li>
            </ul>
        </Card>
    );
}

export default WorkCard;
